<form #ngForm="ngForm" [ngClass]="styles.editForm" (submit)="onSave()">

	<div [ngClass]="styles.left">
		<div [ngClass]="styles.startTime">
			<input type="text" name="start" vbUiTextInput #startTimeRef="ngModel" [(ngModel)]="startTime" [attr.aria-label]="'Start' | translate" required [pattern]="timeRx"/>
			<div *ngIf="startTimeRef.invalid" role="alert" vbUiErrorMessage>

				<div *ngIf="startTimeRef.errors.required">
					{{ 'ThisFieldIsRequired' | translate }}
				</div>

				<div *ngIf="startTimeRef.errors.pattern">
					{{ 'InvalidTimeError' | translate }}
				</div>
			</div>
		</div>

		<div [ngClass]="styles.endTime">
			<input type="text" name="end" vbUiTextInput #endTimeRef="ngModel" [(ngModel)]="endTime" [attr.aria-label]="'End' | translate" required [pattern]="timeRx">
			<div role="alert" *ngIf="endTimeRef.invalid" vbUiErrorMessage>

				<div *ngIf="endTimeRef.errors.required">
					{{ 'ThisFieldIsRequired' | translate }}
				</div>

				<div *ngIf="endTimeRef.errors.pattern">
					{{ 'InvalidTimeError' | translate }}
				</div>
			</div>
		</div>
	</div>

	<div [ngClass]="styles.center">
		<div [ngClass]="[
				styles.contentInput,
				textInvalid ? styles.invalid : ''
			]" #textInput role="textbox" [attr.aria-label]="'Subtitle' | translate" [attr.aria-multiline]="'true'" [attr.aria-required]="'true'" contenteditable (input)="updateText($event.target)" (blur)="updateText($event.target)">
		</div>
	</div>

	<button type="submit" class="btn" vbUiBtnPrimary [ngClass]="styles.saveBtn" [disabled]="ngForm.invalid" [attr.aria-label]="'Save' | translate">
		<span class="vb-icon vb-icon-save"></span>
	</button>

	<button type="button" class="btn" [ngClass]="styles.deleteBtn" (click)="delete.emit()" [attr.aria-label]="'Delete' | translate">
		<span class="glyphicons bin"></span>
	</button>

	<button type="button" class="btn" [ngClass]="styles.closeBtn" (click)="cancel.emit()" [attr.aria-label]="'Cancel' | translate">
		<span class="glyphicons remove_2"></span>
	</button>
</form>
